/**
 *
 * Asynchronously loads the component for DocumentCenter
 *
 */

import loadable from "../../utils/loadable";

export default loadable(() => import("./index"));
